import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AvatarInvertedPortfolio } from '../../XcalaComponents/AvatarInvertedPortfolio';
import WrapperBackgroundBanner from '../../XcalaComponents/WrapperBackgroundBanner';
import WrapperContentApp from '../../XcalaComponents/WrapperContentApp';

const HeaderDetailsPorfolio = ({ fileAs }) => {
  const [userNotOB, setUserNotOB] = useState(false);
  const user = useSelector(state => state.auth.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      user?.['custom:checkid-sign-doc'] &&
      user['custom:checkid-sign-doc'] === 'signature_success'
    ) {
      setUserNotOB(true);
    }
  }, [user]);
  return (
    <>
      <WrapperBackgroundBanner>
        <WrapperContentApp fileAs={fileAs}>
          <AvatarInvertedPortfolio porfolioDetailHeader={fileAs} />
        </WrapperContentApp>
      </WrapperBackgroundBanner>
    </>
  );
};

export default HeaderDetailsPorfolio;
